import React from 'react';
import { Card, Select, Input, Space, Button } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import type { FileListFilters } from '../../hooks/useFileList';

interface Props {
  filters: FileListFilters;
  onFilterChange: (filters: FileListFilters) => void;
  onReset: () => void;
}

/**
 * ファイル一覧のフィルターコンポーネント
 */
export function FileFilters({ filters, onFilterChange, onReset }: Props) {
  const handleChange = <K extends keyof FileListFilters>(key: K, value: FileListFilters[K]) => {
    onFilterChange({
      ...filters,
      [key]: value,
      page: 1, // フィルター変更時はページをリセット
    });
  };

  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <Space wrap size="middle">
        {/* ファイルタイプ */}
        <div>
          <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>ファイルタイプ</div>
          <Select
            style={{ width: 150 }}
            placeholder="すべて"
            allowClear
            value={filters.fileType}
            onChange={(value) => handleChange('fileType', value)}
            options={[
              { label: '📷 写真', value: 'photo' },
              { label: '🎥 動画', value: 'video' },
              { label: '📄 文書', value: 'document' },
              { label: '📦 その他', value: 'other' },
            ]}
          />
        </div>

        {/* ストレージクラス */}
        <div>
          <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>保存場所</div>
          <Select
            style={{ width: 180 }}
            placeholder="すべて"
            allowClear
            value={filters.storageClass}
            onChange={(value) => handleChange('storageClass', value)}
            options={[
              { label: '🔵 アクティブ (S3)', value: 'STANDARD' },
              { label: '📦 アーカイブ (Glacier)', value: 'GLACIER_IR' },
              { label: '🗄️ 深層アーカイブ', value: 'DEEP_ARCHIVE' },
            ]}
          />
        </div>

        {/* 並び順 */}
        <div>
          <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>並び順</div>
          <Select
            style={{ width: 160 }}
            value={filters.sortBy}
            onChange={(value) => handleChange('sortBy', value)}
            options={[
              { label: '更新日（新しい順）', value: 'createdAt' },
              { label: 'ファイル名', value: 'fileName' },
              { label: 'サイズ', value: 'fileSize' },
              { label: '最終アクセス', value: 'lastAccessedAt' },
            ]}
          />
        </div>

        {/* 検索 */}
        <div>
          <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>検索</div>
          <Input
            style={{ width: 200 }}
            placeholder="ファイル名で検索..."
            prefix={<SearchOutlined />}
            allowClear
            value={filters.searchQuery}
            onChange={(e) => handleChange('searchQuery', e.target.value)}
          />
        </div>

        {/* リセットボタン */}
        <div style={{ paddingTop: 20 }}>
          <Button
            icon={<ReloadOutlined />}
            onClick={onReset}
          >
            リセット
          </Button>
        </div>
      </Space>
    </Card>
  );
}
